import AuthService from '@/modules/auth/authService';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { i18n, init as i18nInit } from 'src/i18n';
import App from './App';
import './index.css';
import { AuthToken } from './modules/auth/authToken';
import SettingsService from './modules/settings/settingsService';
import TenantService from './modules/tenant/tenantService';

// Aplicar tema inmediatamente para evitar parpadeo
SettingsService.applyThemeFromTenant();

const container = document.getElementById('root')!;
const root = createRoot(container);

(async function () {
  try {
    // Check for social auth onboarding
    const isSocialOnboardRequested =
      AuthService.isSocialOnboardRequested();
    AuthToken.applyFromLocationUrlIfExists();

    // Initialize services in parallel
    await Promise.all([
      TenantService.fetchAndApply(),
      i18nInit(),
      isSocialOnboardRequested
        ? AuthService.socialOnboard()
        : Promise.resolve(),
    ]);

    // Update title after i18n is initialized
    document.title = i18n('app.title');

    // Render the app
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    // Aquí podrías mostrar un mensaje de error amigable
    document.body.innerHTML = `
      <div style="
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
        font-family: system-ui;
        color: #666;
      ">
        <div style="text-align: center;">
          <h2>Unable to load application</h2>
          <p>Please try refreshing the page</p>
        </div>
      </div>
    `;
  }
})();
